export default {
    lang: "fa",
};
